import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-publish-to-web',
  templateUrl: './publish-to-web.component.html',
  styleUrls: ['./publish-to-web.component.scss']
})
export class PublishToWebComponent {
  @Input() checked: boolean = false;
  @Input() id: string = 'publishToWeb-readonly';
}
